export var toDate = function (value) {
    var date;
    if (value) {
        if (typeof value == 'string' || typeof value == 'number') {
            date = new Date(value);
            if (isNaN(date.getTime())) {
                date = null;
            }
            return date;
        }
    }
    return value;
};
export var formatDateTime = function (value) {
    var date = toDate(value);
    if (date) {
        if (date.getHours() == 0 && date.getMinutes() == 0 && date.getSeconds() == 0 && date.getMilliseconds() == 0) {
            return date.localeFormat('dd.MM.yyyy');
        }
        return date.localeFormat('dd.MM.yyyy HH:mm') + ' Uhr';
    }
};
export var formatDate = function (value) {
    var date = toDate(value);
    if (date) {
        return date.localeFormat('dd.MM.yyyy');
    }
};
export var dayOfWeek = function (value) {
    var date = toDate(value);
    if (date) {
        var day = date.getDay();
        switch (day) {
            case 0:
                return 'So';
            case 1:
                return 'Mo';
            case 2:
                return 'Di';
            case 3:
                return 'Mi';
            case 4:
                return 'Do';
            case 5:
                return 'Fr';
            case 6:
                return 'Sa';
        }
    }
};
